"use client"

import React, { useEffect, useRef, forwardRef, useImperativeHandle } from "react"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"

const Ckeditor = forwardRef(({ activeClass, data, onChange }, ref) => {
  const quillRef = useRef(null)
  const [content, setContent] = React.useState(data || "")

  useImperativeHandle(
    ref,
    () => ({
      editor: {
        insertHtml: (text) => {
          if (quillRef.current) {
            const quill = quillRef.current.getEditor()
            const range = quill.getSelection(true)
            quill.insertText(range.index, text)
            quill.setSelection(range.index + text.length)
          }
        },
        focus: () => {
          if (quillRef.current) {
            quillRef.current.getEditor().focus()
          }
        },
        destroy: () => {
          // ReactQuill handles cleanup automatically
          console.log("ReactQuill editor reference cleared")
        },
      },
    }),
    [],
  )

  // Sync content with props.data
  useEffect(() => {
    if (data !== content && data !== undefined) {
      setContent(data)
    }
  }, [data])

  // Handle change
  const handleChange = (newContent) => {
    console.log("onChange fired with content:", newContent)
    setContent(newContent)
    if (onChange) {
      onChange(newContent)
    }
  }

  return (
    <div className={activeClass || ""}>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={content}
        onChange={handleChange}
        modules={{
          toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline", "strike"],
            ["link", "image"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
          ],
        }}
      />
    </div>
  )
})

Ckeditor.displayName = "Ckeditor"

export default Ckeditor
